
import axios from '@/http'
import { getSearchParamByName } from '@/utils'

const project = getSearchParamByName('project') || ''

export const getServerTime = () => {
  return axios.get('common/current_time')
}

// 获取短信验证码
export const getPhoneCode = (phone) => {
  return axios.post('/app/verificationcode', {
    phone,
    project
  })
}

// 手机号登录
export const phoneLogin = (params) => {
  return axios.post('/app/user/phonelogin', {
    phone: params.phone,
    code: params.code,
    project
  })
}

export const checkLogin = () => {
  return axios.get('/app/user/checklogin')
}

export const register = (params) => {
  return axios.post('/app/user/register', {
    email: null,
    nickname: null,
    password: params.password,
    phone: params.phone,
    project,
    username: params.username
  })
}

export const login = (params) => {
  return axios.post('/app/user/login', {
    project,
    username: params.username,
    password: params.password
  })
}

export const logout = () => {
  return axios.post('/app/user/logout')
}

export const getTicketList = (params) => {
  if (!project) return

  return axios.get('/app/tickettype', {
    params: {
      pageNum: params.pageNum,
      pageSize: params.pageSize,
      type: params.type,
      project: project
    }
  })
}

export const getTicketDetail = (id, params) => {
  return axios.get(`/app/tickettype/${id}/${project}`, params)
}

export const createOrder = (params) => {
  return axios.post('/app/order', params)
}

export const getOrderDetail = (id) => {
  return axios.get(`/app/order/${id}`)
}

export const getWxQrcode = (params) => {
  return axios.post('/wxpay/newpaynative', {
    project_name: project,
    order_no: params.order_no,
    fee: params.fee
  })
}

export const getAliQrcode = (params) => {
  return axios.post('/alipay/newpay', {
    project_name: project,
    order_no: params.order_no,
    fee: params.fee
  })
}
export const getJianHangQrcode = (params) => {
  return axios.post('/app/jianhang/newpay', {
    project_name: project,
    order_no: params.order_no,
    fee: params.fee
  })
}
export const getJianHangPayStatus = (order_no) => {
  return axios.get(`/jianhang/ebs/doPayQuery?order_no=${order_no}`)
}

export const getOrderList = (params) => {
  return axios.get('/app/order', {
    params: params
  })
}

export const cancelOrder = (id) => {
  return axios.delete(`/app/order/${id}`)
}
export const cancelPart = (params) => {
  return axios.post(`/app/order/cancelpart`, params)
}
export const changeTicket = (id, params) => {
  return axios.post(`/app/order/${id}/changeticket`, params)
}
export const getTicketInfo = (params) => {
  const { id, start, end } = params
  return axios.get(`/app/tickettype/${id}`, {
    params: {
      project,
      start,
      end
    }
  })
}

// 项目设置
export const getProjectConfig = (params) => {
  return axios.get(`app/config/project?project=${project}`)
}
